import { FunctionIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopText, ScoopColumn } from '../../../../ui'
import { useModal, MODALS } from '../../../../modals'
import styles from './EmptyCalculatedColumns.module.scss'

export const EmptyCalculatedColumns = ({ inboxID }) => {
    const calculatedColumnsModal = useModal(MODALS.SOURCE.CALCULATED_COLUMNS)

    return (
        <ScoopColumn className={styles.container}>
            <FunctionIcon size={32} />
            <ScoopText className={styles.title}>Calculated Columns</ScoopText>
            <ScoopButton
                variant="grey"
                size="xs"
                onClick={() => calculatedColumnsModal.show({ inboxID })}
            >
                Create Calculated Columns
            </ScoopButton>
        </ScoopColumn>
    )
}
